import { configureStore } from "@reduxjs/toolkit";
import { authApi, authSlice } from "@modules/auth";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { productApi, productSlice } from "@modules/product";
import { imageApi } from "@modules/images";
import { messageApi, messageSlice } from "@modules/messages";
import { certificateCategoryApi, categorySlice } from "@modules/category";
import { certificateApi, certificateSlice } from "@modules/certificate";

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    category: categorySlice.reducer,
    product: productSlice.reducer,
    message: messageSlice.reducer,
    certificate: certificateSlice.reducer,
    [certificateApi.reducerPath]: certificateApi.reducer,
    [certificateCategoryApi.reducerPath]: certificateCategoryApi.reducer,
    [imageApi.reducerPath]: imageApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [messageApi.reducerPath]: messageApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      certificateApi.middleware,
      certificateCategoryApi.middleware,
      imageApi.middleware,
      authApi.middleware,
      productApi.middleware,
      messageApi.middleware
    ]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
